export const getTicketProfileUrl = ({
  portalId,
  ticketId
}) => `/contacts/${portalId}/ticket/${ticketId}`;